// extracted by mini-css-extract-plugin
export default {"container":"PatientSections_container__CtRig","title":"PatientSections_title__c5fkQ"};